import useApiMutation from 'shared/hooks/use-api-mutation';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface CreateBonusProps {
  userId: string;
  bonus: number;
}

export const translatedCreateBonusProps: TranslatedKeys<CreateBonusProps> = {
  userId: 'Usuário',
  bonus: 'Valor do bônus',
};

const useCreateBonus = () => {
  return useApiMutation<CreateBonusProps>({
    url: '/transaction-records/bonus',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar bônus',
    successTitle: 'Cadastrar bônus',
    successMessage: 'Bônus cadastrado com sucesso',
  });
};

export default useCreateBonus;
